export class SearchInfo {
    public SearchCriteria: string;
    public SearchValue: string;
    public RemoveCancelled: boolean;
    public Dashboard: boolean;
    public FilterWithDealer: boolean;
}
